<template>
  <div class="block">
    <el-carousel :height="height">
      <el-carousel-item v-for="item in bannerData" :key="item.id">
        <img :src="item.imgUrl" alt="" width="100%" height="100%" @click="toJump(item.jumpUrl)">
      </el-carousel-item>
    </el-carousel>
  </div>
</template>
<script>
export default {
  name: 'Banner',
  props: {
    bannerData: { // banner数组
      type: Array,
      default: () => {
        return []
      }
    },
  },
  data() {
    return {
      activeIndex: 0,
      timer: null,
      height: '30rem',
      WidthTimer: false,
      screenWidth: document.body.clientWidth,
    }
  },
  watch: {
    screenWidth: {
      immediate: true,
      handler: function (newVal) {
        console.log("newVal",newVal);
        
        // 为了避免频繁触发resize函数导致页面卡顿，使用定时器
        if (!this.WidthTimer) {
          this.screenWidth = newVal;
          this.WidthTimer = true;
          let _this = this;
          setTimeout(() => {
            //在这里做有关浏览器变化时需要做的操作
            _this.WidthTimer = false;
            _this.getWindowInfo();
          }, 400);
        }
        // if(newVal)
      }
    }
  },
  mounted() {
    setTimeout(() => {
      this.onStart()
    }, 1000)
    window.onfocus = () => { // 页面激活
      this.onStart()
    }
    window.onblur = () => { // 页面失焦
      this.onStop()
    }

    window.addEventListener("resize", () => {
      this.screenWidth = document.body.clientWidth;
    });
  },
  methods: {
    toJump(url) {
      // console.log("url-1",url);
      if (url) {
        window.open(url, "_blank")
      }
    },
    onStart() {
      clearInterval(this.timer)
      if (this.bannerData.length > 1) {
        this.timer = setInterval(this.onMove, this.interval)
      }
    },
    getWindowInfo() {
      if (this.screenWidth > 540 && this.screenWidth < 800) {
        this.height = '20rem'
      }else if (this.screenWidth <= 540) {
        this.height = '15rem'
      } else {
        this.height = '30rem'
      }
    },

    onStop() {
      clearInterval(this.timer)
    },
    onEnter(index) {
      if (index < 0) {
        index = this.bannerData.length - 1
      }
      if (index > this.bannerData.length - 1) {
        index = 0
      }
      clearInterval(this.timer)
      this.activeIndex = index
      this.onStart()
    },
    onMove() {
      if (this.activeIndex === this.bannerData.length - 1) {
        this.activeIndex = 0
      } else {
        this.activeIndex++
      }
    }
  },
  beforeDestroy() {
    clearInterval(this.timer)
    this.timer = null
  }
}
</script>
<style lang="less" scoped>
.el-carousel__item h3 {
  color: #475669;
  font-size: 1rem;
  opacity: 0.75;
  line-height: 15rem;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #ffffff;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #ffffff;
}
</style>
